import { NavLink } from 'react-router';
import { Percent, Scroll } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Pestana {
  a: string;
  etiqueta: string;
  icono: LucideIcon;
}

const PESTANAS: Pestana[] = [
  { a: '/exoneraciones', etiqueta: 'Exoneraciones', icono: Percent },
  { a: '/exoneraciones/tipos', etiqueta: 'Tipos', icono: Scroll },
];

export function PestanasDeExoneraciones() {
  return (
    <nav
      aria-label="Áreas de exoneraciones"
      className="mb-6 flex gap-1 overflow-x-auto border-b border-armazon-200"
    >
      {PESTANAS.map(({ a, etiqueta, icono: Icono }) => (
        <NavLink
          key={a}
          to={a}
          end={a === '/exoneraciones'}
          className={({ isActive }) =>
            [
              'flex shrink-0 items-center gap-2 border-b-2 px-4 py-3 text-[13px] font-semibold uppercase tracking-wide transition-colors',
              isActive
                ? 'border-amber-500 text-armazon-900'
                : 'border-transparent text-armazon-400 hover:text-armazon-600',
            ].join(' ')
          }
        >
          {({ isActive }) => (
            <>
              <Icono
                className={`size-4 shrink-0 ${isActive ? 'text-amber-500' : ''}`}
                aria-hidden
              />
              {etiqueta}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
